import { css } from '@microsoft/fast-element';
import { neutralForegroundRest, neutralStrokeRest, getToken } from '../../design-tokens';
import { heightNumber, paddingNumber } from '../../styles/size';
import { mediaSizeBehavior } from '../../utilities/media-size-observer';
import { display } from '../../foundation/display';

export const navBarStyles = css`
    ${display('block')}

    :host {
        background: ${getToken('ui-nav-bar-color-background')};
        color: ${neutralForegroundRest};
    }

    :host([container]) {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .container {
        display: flex;
        align-items: center;
        justify-content: center;

        box-sizing: border-box;
        padding: 0 calc(${paddingNumber} * 1px);
        width: 100%;
        height: calc(${heightNumber} * 2px);
    }

    .border {
        width: 100%;
        height: calc(${getToken('ui-nav-bar-space-border-width')} * 1px);;
    }

    natgen-hamburger-button::part(overlay) {
        top: calc(${heightNumber} * 2px);
        height: calc(100vh - (${heightNumber} * 2px));
    }

    ::slotted(natgen-side-bar), natgen-side-bar {
        position: absolute;
        height: 100%;
        z-index: 10;
    }

    natgen-side-bar.default {
        border-right: calc(${getToken('space-stroke-width')} * 1px) solid ${neutralStrokeRest};
        padding: calc(${paddingNumber} * 1px);
    }

    nav {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        flex-grow: 1;
        gap: calc(${paddingNumber} * 1px);

        width: auto;
        height: 100%;
    }

    .main-menu {
        justify-self: flex-start;
    }

    .logo {
        margin: 0 auto;
    }

    .end {
        justify-self: flex-end;
    }
`.withBehaviors(
    mediaSizeBehavior('small',
        css`
            :host([container]) .container {
                width: calc(${getToken('space-breakpoint-small')} * 1px);
            }
        `
    ),
    mediaSizeBehavior('medium',
        css`
            :host([container]) .container {
                width: calc(${getToken('space-breakpoint-medium')} * 1px);
            }
        `
    ),
    mediaSizeBehavior('large',
        css`
            :host([container]) .container {
                width: calc(${getToken('space-breakpoint-large')} * 1px);
            }
        `
    ),
    mediaSizeBehavior('extra-large',
        css`
            :host([container]) .container {
                width: calc(${getToken('space-breakpoint-extra-large')} * 1px);
            }
        `
    ),
);
